<template>
  <div>
    <vue-splash
      :show="true"
      :logo="logo"
      color="#00a0ff"
      :size="300"
      :fixed="true"
    />
  </div>
</template>

<script>
import YourLogo from '@/assets/logo.png';

export default {
  name: process.env.VUE_APP_NAME,
  computed: {
    logo() {
      return YourLogo;
    },
  },
};
</script>
